import { writable } from 'svelte/store';
import { localStorageStore } from '../../../utils';
export const dismissableBanners = localStorageStore("dismissable_banners", {});
export const scrollbarWidth = writable(0);
export const drawerOpen = writable(false);
